var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var Heart = function Heart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36585 4.7998C4.04057 4.7998 2 7.66238 2 10.0103C2 15.0873 7.86207 19.7998 12 22.7998C16.1379 19.7998 22 15.0873 22 10.0103C22 7.66238 19.9594 4.7998 16.6342 4.7998C14.777 4.7998 13.1905 6.2573 12 7.64192C10.8095 6.2573 9.22297 4.7998 7.36585 4.7998Z",
    fill: "currentColor",
    fillOpacity: "0.96"
  })));
};